<script>

    import Moment from 'moment'
    import { toast } from 'bulma-toast'
    import { stpOrdenesStore, modalStore } from '../stores'

    import StpService from '../$services/stp.service'
    import StpMethods from '../$methods/stp.methods'
    import DateMethods from '../$methods/date.methods'
    import TranslateMethods from '../$methods/translate.methods'
    import NumeralMethods from '../$methods/numeral.methods'

    import Button from '../$components/button.svelte'
    import ButtonOpen from '../$components/button.open.svelte'
    import Search from '../$components/input.search.svelte'
    import Table from '../$components/table.svelte'
    import Modal from '../$components/modal.container.svelte'
    import OrdenCreate from './component.create.svelte'

    let loading = false
    let metadata = {}
    let query = {
        page: 0,
        find: null,
    }

    getOrdenes()

    async function getOrdenes() {

        loading = true
        const resp = await StpService.getOrdenes(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        stpOrdenesStore.set(resp.data.ordenes)
        metadata = resp.data.metadata
    }

</script>

<Table
    items={ $stpOrdenesStore.length }
    total={ metadata.total }
    { loading }
    skeletonCols={9}
    bind:metadata
    bind:page={ query.page }
    on:change={ getOrdenes }
>
    <div slot="header" class="header-filters">
        <div class="header-top">
            <Search bind:value={ query.find } on:enter={ getOrdenes } />
            <Button text="Agregar" icon="plus" color="primary" on:click={() => modalStore.set('stp_orden_create_modal')} />
        </div>
    </div>
    <thead slot="thead">
        <tr>
            <th>#</th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-user"></i></span>
                    <span>Beneficiario</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-university"></i></span>
                    <span>Institución</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-dollar-sign"></i></span>
                    <span>Monto</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-file-alt"></i></span>
                    <span>Concepto</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-clipboard-check"></i></span>
                    <span>Estatus</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-calendar"></i></span>
                    <span>Fecha</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-ellipsis-v"></i></span>
                    <span>Acciones</span>
                </span>
            </th>
        </tr>
    </thead>
    <tbody slot="tbody">
        {#each $stpOrdenesStore as orden, index}
            <tr>
                <td><span>{ metadata?.items != null ? (metadata.items * (query.page ?? 0)) + (index + 1) : index + 1 }</span></td>
                <td>
                    <div class="td-stack">
                        <div>{ orden.nombreBeneficiario }</div>
                        <small>{ orden.cuentaBeneficiario }</small>
                    </div>
                </td>
                <td>{ StpMethods.getInstitucion(orden.institucionContraparte) }</td>
                <td>{ NumeralMethods.cash(orden.monto) }</td>
                <td>{ orden.conceptoPago }</td>
                <td>{ TranslateMethods.get(orden.estado?.estado ?? 'pending') }</td>
                <td>{ DateMethods.dateTimeLarge(Moment(`${orden.fechaOperacion}`, 'YYYYMMDD').toDate()) }</td>
                <td>
                    <ButtonOpen on:click={() => modalStore.open('stpOrden', 'modal', orden)} />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>

<Modal id="stp_orden_create_modal" title="Crear orden STP">
    <OrdenCreate />
</Modal>
